export default __webpack_public_path__ + "static/media/ic_arbitrum_16.f4c1a9fe.svg";